"use strict";

class MountSchemeSelect {
    constructor(selectBox = "MountSchemeSelectBox", initALL = true) {
        this.selectBox = selectBox;
        console.log(`Init Mounting Scheme select interactive box module`);
        if (initALL) this.initDialog();
    }

    initDialog() {
        // init interactive act
        $('#' + this.selectBox)
            .on('shown.bs.modal', (event) => this.loadControlsValues(event))
            .on('hidden.bs.modal', () => this.finalizeBox())
            .on('keypress', (event) => {
                if (event.keyCode === 10 || event.keyCode === 13) {
                    this.onConfirm(event);
                    event.preventDefault();
                }
            })
            .find("button.confirm")
                .on('click', (event) => this.onConfirm(event));

        return this;
    }

    loadControlsValues() {
        let $ITF_frame_schema_controls = $("#ITF_frame .schema-control"),
            selectedSchemeValue = $ITF_frame_schema_controls.filter(".active").find("> input:radio").val(),
            disabled_schemes = [];
        $ITF_frame_schema_controls.filter(".disabled").each((index,item) => {
            disabled_schemes.push("."+$(item).find("> input:radio").val());
        });

        console.log(disabled_schemes.join(","));

        $("#MountSchemeSelectBox .box-schema-control").removeClass("disabled").filter(disabled_schemes.join(",")).addClass("disabled");
        $("#MountSchemeSelectBox .box-schema-control." + selectedSchemeValue).button("toggle");
    }

    onConfirm() {
        $("#ITF_frame .schema-control.active").removeClass("active");
        let selectedScheme = $("#" + this.selectBox).modal("hide").find(".box-schema-control.active > input:radio").val();
        $("#ITF_frame .schema-control").filter("." + selectedScheme).button("toggle");
    }

    finalizeBox() {}
}

export default MountSchemeSelect;
